"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.displayPriorities = void 0;
exports.displayPriorities = function (axios) {
    return {
        getDisplayPriorities: function (getDisplayPrioritiesRequest) {
            return axios.get('/display-priorities', getDisplayPrioritiesRequest);
        },
        postDisplayPriorities: function (_a) {
            var data = _a.data;
            return axios.post('/display-priorities', data);
        },
        getDisplayPrioritiesExcel: function (getDisplayPrioritiesExcelRequest) {
            return axios.get('/display-priorities/excel', getDisplayPrioritiesExcelRequest);
        }
    };
};
